export const RESET = 'EXCMCYCLICTASK_UPDATE_RESET'
export const SET_ERROR = 'EXCMCYCLICTASK_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMCYCLICTASK_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMCYCLICTASK_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMCYCLICTASK_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMCYCLICTASK_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMCYCLICTASK_UPDATE_UPDATE_RETRIEVED'
